export default __webpack_public_path__ + "static/media/Deep2.5d1fc06a.jpeg";